import { getApiErrorMessage, isCognitoRegistrationRequiredError } from '../services/authService';
import { showAppError, showRegisterAppDialog } from '../services/messageDialogService';

export function showAuthError(error, fallbackMessage) {
  if (isCognitoRegistrationRequiredError(error)) {
    showRegisterAppDialog();
    return;
  }

  showAppError(getApiErrorMessage(error, fallbackMessage));
}
